import {Injectable, inject} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router, CanActivateFn} from '@angular/router';
import {RedirectUrlService} from '../redirectUrl-service/redirectUrl.service';
import {KeycloakService} from 'keycloak-angular';

@Injectable({
  providedIn: 'root'
})
class PermissionsService {
  constructor(
    private router: Router,
    private _redirectUrlService: RedirectUrlService,
    private _keycloakService: KeycloakService
  ) {
  }

  async canActivate(_next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    if (await this._keycloakService.getToken() !== '' && await this._keycloakService.getToken() !== undefined) {
      return true;
    } else {
      sessionStorage.setItem('redirectURL', state.url);
      const redirectParam = this._redirectUrlService.getQueryParameterByName(state.url);
      return this.router.createUrlTree(['/login'], redirectParam ? {queryParams: {redirectURL: redirectParam}} : {});
    }
  }
}

export const AuthGuard: CanActivateFn = async (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> => {
  return await inject(PermissionsService).canActivate(next, state);
};
